module.exports = __webpack_public_path__ + "assets/d6afca7ce4d027be010886f264753051.png";